/**
 * Page names for usage rows: a web $pathname → the sidebar's title for it
 * (most specific match wins), a mobile screen ('screen:<name>') → its name.
 * Gates are ignored on purpose: an admin reads about pages other people see.
 */
import { NAV_MAIN, NAV_FOOTER, NAV_SETTINGS, itemMatches } from '../../../../config/navConfig';

function leaves() {
  const out = [];
  const walk = (item, parent) => {
    if (item.to) out.push({ item, title: parent ? `${parent} · ${item.title}` : item.title });
    (item.children || []).forEach((c) => walk(c, item.title));
  };
  NAV_MAIN.forEach((g) => (g.items || []).forEach((i) => walk(i, null)));
  (NAV_FOOTER || []).forEach((i) => walk(i, null));
  if (NAV_SETTINGS) walk(NAV_SETTINGS, null);
  return out;
}

let cached = null;

export function pageTitle(path) {
  const p = String(path || '');
  if (!p) return null;
  if (p.startsWith('screen:')) return p.slice(7).replace(/([a-z])([A-Z])/g, '$1 $2') || 'Mobile app';
  if (!cached) cached = leaves();
  const pathname = p.split('?')[0];
  let best = null;
  cached.forEach((l) => {
    if (!itemMatches(l.item, pathname)) return;
    const len = String(l.item.to).split('?')[0].length;
    if (!best || len > best.len) best = { title: l.title, len };
  });
  return best ? best.title : pathname;
}
